/**
 *
 * Home
 *
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { FormattedMessage } from "react-intl";
import { compose } from "redux";
import { NavLink, Link } from "react-router-dom";

// import HomeScreen from 'pickups-ui-library/stories/screens/home.js'

// import SquareButton from 'pickups-ui-library/components/SquareButton'
import {
  SquareButton,
  PickupQuickView,
  ImageSection,
  Section,
  Slider,
} from "pickups-ui-library";

import { Container, Row, Col } from "reactstrap";

import * as Icons from "pickups-ui-library/styles/icons";

import PageLayout from "containers/UserHeaderLayout";

import { displayPickup } from "utils/helpers";

import messages from "./messages";
import makeSelectPickups, {
  selectPickupsDomain,
  makeSelectUpcomingPickups,
} from "../Pickups/selectors";
import Navigation from "components/Navigation";

const PickupsSlider = ({ title, pickups, history }) => {
  return (
    <>
      {pickups.length ? (
        <Section title={title} count={pickups.length}>
          <Slider
            items={pickups.map((pickup) => {
              const {
                pickupDate,
                type,
                pickupStatus,
                id,
                statusText,
                displayType,
              } = displayPickup(pickup);
              return (
                <PickupQuickView
                  date={pickup.location.fullAddress}
                  type={pickupDate}
                  status={pickupStatus.label}
                  statusText={statusText}
                  layout={"left"}
                  onClick={() => {
                    history.push(`/pickups/${id}`);
                  }}
                  leftButtonLabel={"Track"}
                  rightButtonLabel={"Details"}
                  leftButtonAction={() => {
                    history.push(`/pickups/${id}`);
                  }}
                  rightButtonAction={() => {
                    history.push(`/pickups/${id}/details`);
                  }}
                />
              );
            })}
          />
        </Section>
      ) : (
        <div className={"box p-4 mb-3 center"}>
          <PickupQuickView
            date={"Schedule a Donation Pickup"}
            type={``}
            status={"OutForPickup"}
            // statusText={'Click here to get started'}
            layout={"left"}
            onClick={() => {
              history.push(`/schedule`);
            }}
          />
        </div>
      )}
    </>
  );
};

function Home(props) {
  const { history, user, pickups, upcomingPickups } = props;

  return (
    <PageLayout>
      <Helmet>
        <title>Home</title>
        <meta name="description" content="Description of Home" />
      </Helmet>
      <Container>
        <PickupsSlider
          title={"Upcoming Pickups"}
          pickups={upcomingPickups}
          history={history}
        />
      </Container>
      <Container>
        <Row noGutters>
          <Col xs={6} className={"p-2"}>
            <Link to="/tax-receipts">
              <SquareButton
                layout={"top"}
                onClick={() => {}}
                label={"Tax Receipts"}
                Icon={Icons.TaxReceipt}
                link={"http://google.com"}
              />
            </Link>
          </Col>
          <Col xs={6} className={"p-2"}>
            <NavLink to="/schedule" exact activeClassName="active">
              <SquareButton
                layout={"top"}
                onClick={() => {}}
                label={"Schedule a Pickup"}
                Icon={Icons.OutForPickup}
                link={"http://google.com"}
              />
            </NavLink>
          </Col>
          <Col xs={6} className={"p-2"}>
            <NavLink to="/settings/account" exact activeClassName="active">
              <SquareButton
                layout={"top"}
                onClick={() => {}}
                label={"Your Profile"}
                Icon={Icons.Profile}
                link={"http://google.com"}
              />
            </NavLink>
          </Col>
          <Col xs={6} className={"p-2"}>
            <NavLink to="/pickups" exact activeClassName="active">
              <SquareButton
                layout={"top"}
                onClick={() => {}}
                label={"Your Pickups"}
                Icon={Icons.Complete}
                link={"http://google.com"}
              />
            </NavLink>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  );
}

Home.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

const mapStateToProps = (state) => ({
  user: { ...state.user },
  pickups: selectPickupsDomain(state),
  upcomingPickups: makeSelectUpcomingPickups(state),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Home);
